import  * as Yup from 'yup';

export const signUpSchema = Yup.object().shape({
  // userName: Yup.string().required("user name is a required field"),
  email: Yup.string().email().required("email is a required field"),
  password: Yup.string().min(4).max(10).required(),
  confirmPassword: Yup.string().oneOf([Yup.ref('password'), null]),
  // termsConditions: Yup.string().required(),
  firstName: Yup.string().required("first name is a required field"),
  lastName: Yup.string().required("last name is a required field"),
  otherName: Yup.string(),
  gender:  Yup.string().oneOf(["male", "female", "preferNotToSpecify"])
      .required(),
  phoneNumber: Yup.string().min(10).max(10).required("phone required"),
  address: Yup.string().min(5).required("Address is required"),
  userAddress: Yup.string().min(5).required("Your Address ius required"),
  localGovt: Yup.string().required(),
  state: Yup.string().required(),
  cacNumber: Yup.string().required(),
  industry: Yup.string().required("industry type is required"),
  businessName: Yup.string().required("business name is required"),
  about: Yup.string().required(),
  businessEmail: Yup.string().required("business email is required"),
  businessPhone: Yup.string().required("business line is required"),
  maritalStatus:  Yup.string().oneOf(["single", "married", "divorced", "widow", "widower"])
      .required(),
  qualification: Yup.string().required("qualification is required"),
  dateOfBirth: Yup.string().required("date of birth is required"),
});

export const createUserSchema = Yup.object().shape({
  userName: Yup.string().required("user name is a required field"),
  emailAddress: Yup.string().email().required("email is a required field"),
  firstName: Yup.string().required("first name is a required field"),
  lastName: Yup.string().required("last name is a required field"),
  userAddress: Yup.string().required("user Address is a required field"),
  password: Yup.string().min(8).max(15).required().matches(
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
  "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"),
  phoneNumber: Yup.string().min(11).max(11).required("phone is required"),
 /* userRole:  Yup.string().oneOf(["admin1", "admin2", "user"])
    .required(),*/
});

export const createClientSchema = Yup.object().shape({
  clientName: Yup.string().required("client name is a required field"),
  maximumHits: Yup.string().required("max Hits is a required field"),
  creditLimit: Yup.string().required("credit Limit is a required field"),
  contactFirstName:  Yup.string().required("first name is a required field"),
  contactLastName: Yup.string().required("last name is a required field"),
  contactPhoneNumber: Yup.string().min(10).max(14).required("phone required"),
  contactEmailAddress: Yup.string().email().required("email is a required field"),
  applicationType:  Yup.string().oneOf(["general", "clientSpecific"])
    .required(),
  password: Yup.string().min(8).max(15).required().matches(
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
    "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"),
});

export const loginSchema = Yup.object().shape({
  // userName: Yup.string().required("user name is a required field"),
  emailAddress: Yup.string().email().required("email is a required field"),
  // firstName: Yup.string().required("first name is a required field"),
  // lastName: Yup.string().required("last name is a required field"),
  password: Yup.string().min(4).max(15).required(),
  // phoneNumber: Yup.string().min(11).max(11).required("phone is required"),
});

const ogaPhoneSchema = Yup.string()
  .test(
    'valid-phone-number',
    'Enter a valid Nigerian phone number',
    (value) => {
      if (!value) return true;
      const digits = String(value).replace(/\D/g, '');
      return digits.length >= 10 && digits.length <= 15;
    },
  );

export const ogaLoginSchema = Yup.object().shape({
  emailAddress: Yup.string()
    .trim()
    .min(3, 'Enter your email or username')
    .required('Email or username is required'),
  password: Yup.string().required('Password is required'),
});

export const ogaRegisterSchema = Yup.object().shape({
  companyName: Yup.string().trim().required('Company name is required'),
  rcNumber: Yup.string().trim().max(50).optional(),
  userName: Yup.string()
    .trim()
    .min(3, 'Login username must be at least 3 characters')
    .max(50, 'Login username must be 50 characters or fewer')
    .required('Login username is required'),
  emailAddress: Yup.string()
    .trim()
    .email('Enter a valid email address')
    .required('Company email address is required'),
  phoneNumber: ogaPhoneSchema.required('Company phone number is required'),
  contactPhoneNumber: ogaPhoneSchema.required(
    'Primary contact phone number is required',
  ),
  password: Yup.string()
    .min(8, 'Password must be at least 8 characters')
    .max(20, 'Password must be 20 characters or fewer')
    .required('Password is required')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/,
      'Password must contain at least one uppercase letter, one lowercase letter and one number',
    ),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
    .required('Please confirm your password'),
  cityName: Yup.string().trim().required('Town or area is required'),
  streetNumber: Yup.string()
    .trim()
    .required('Street number and name are required'),
  lga: Yup.string().required('LGA is required'),
  landmark: Yup.string().trim().optional(),
  latitude: Yup.number()
    .transform((value, original) => (original === '' ? undefined : value))
    .min(-90, 'Latitude must be between -90 and 90')
    .max(90, 'Latitude must be between -90 and 90')
    .optional(),
  longitude: Yup.number()
    .transform((value, original) => (original === '' ? undefined : value))
    .min(-180, 'Longitude must be between -180 and 180')
    .max(180, 'Longitude must be between -180 and 180')
    .optional(),
  state: Yup.string().required('State is required'),
  firstName: Yup.string().trim().required('Primary contact first name is required'),
  lastName: Yup.string().trim().required('Primary contact last name is required'),
  vitelPhoneNumber: ogaPhoneSchema.optional(),
  referralAgentCode: Yup.string().trim().optional(),
  amount: Yup.number()
    .typeError('Enter a valid amount')
    .min(10000, 'Minimum top-up amount is N10,000')
    .required('Enter an amount to fund your e-Wallet'),
  termsConditions: Yup.boolean()
    .oneOf([true], 'Accept the Terms and Conditions to continue')
    .required('Accept the Terms and Conditions to continue'),
});

export const phoneSearchSchema = Yup.object().shape({
  phoneNumber: Yup.string().min(11).max(14).required("phone is required"),
});
export const cgiReportsSearchSchema = Yup.object().shape({
  startDate: Yup.string().required("Start date is required"),
  endDate: Yup.string().required("end date is required"),
  clientUserName: Yup.string().required("client User Name is required"),
});

export const dateRangeSchema = Yup.object().shape({
  startDate: Yup.string().required("Start date is required"),
  endDate: Yup.string().required("end date is required"),
});

export const agreementAuthCode = Yup.object().shape({
  agreeAuthCode: Yup.string().required("Code is required").matches(/^[a-zA-Z0-9 .,+-]{8}$/),
  phoneNumber: Yup.string().min(13).max(14).required("phone is required"),
});

export const addDeviceSchema = Yup.object().shape({
  phoneNumber: Yup.string().min(13).max(14).required("phone is required"),
  alias: Yup.string().required("alias name is a required field"),
  frequency: Yup.string().required("frequency  is a required field"),
});

export const resetPasswordSchema = Yup.object().shape({
  // userId:Yup.string(),
  newPassword: Yup.string().min(4).required("password is empty").matches(
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
    "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"),
  confirmNewPassword: Yup.string().oneOf([Yup.ref('newPassword'), null]),
});
